import {
  ArrowShape,
  Alignment,
  AvatarIcon,
  Direction,
  Layout,
  LoggedInTextState,
} from '../LoginSocialBar.types';

export const defaultCompData = {
  loggedOutCustomAvatar: '',
  loggedInCustomAvatar: '',
  loggedInTextState: LoggedInTextState.MemberName,
  loggedOutMember: Layout.AvatarAndText,
  loggedInMember: Layout.AvatarAndText,
  loggedInAvatarIcon: AvatarIcon.ProfileImage,
  loggedOutAvatarIcon: AvatarIcon.ProfileImage,
  showLoggedInText: false,
} as const;

export const defaultCompProps = {
  arrowSize: 14,
  arrowShape: ArrowShape.Line,
  iconSize: 26,
  loggedOutIconSize: 26,
  showBellIcon: true,
  dropDownTextAlignment: Alignment.Left,
  buttonsAlignment: Alignment.Right,
  buttonsDirection: Direction.LTR,
} as const;
